export const SyncStatus = {
  SYNCED: "synced",
  WAITING: "waiting",
  ERROR: "error",
  OFFLINE: "offline",
};

export const MessageStatus = {
  SENT: "sent",
  SENDING: "sending",
  ERROR_MEDIA: "error_media",
  ERROR_MESSAGE: "error_message",
  // DELETED: "deleted",
};

export const Chat = {
  MEDIA_HEIGHT: 250,
  MEDIA_WIDTH: 200,
  MEDIA_REPLY_HEIGHT: 140,
  MEDIA_REPLY_WIDTH: 100,
  AUDIO_REPLY_WIDTH: 150,
  // CHAT_WIDTH: 390,
  CHAT_WIDTH: 400,
  CHAT_WIDTH_EXPANDED: 800,
  // CHAT_WIDTH_SMALL: 340,
};

export const BlockPlanificationConstants = {
  COLUMN_WIDTH: 372,
  COLUMN_GAP: 8,
  WORKOUT_GAP: 8,
  WORKOUT_MIN_HEIGHT: 440,
  WORKOUT_HEADER_HEIGHT: 40,
  VALUE_PILL_WIDTH: 65,
  VALUE_PILL_HEIGHT: 24,
  TOAST_DURATION_MS: 3000,
  // Mobile-specific values for tighter layout
  MOBILE_COLUMN_WIDTH: 316,
  MOBILE_VALUE_PILL_WIDTH: 58,
  MOBILE_VALUE_PILL_HEIGHT: 26,
};

export const AspectRatios = {
  AccederConGoogle: 740 / 184,
  AdaptiveIcon: 1024 / 1024,
  AppStore: 1280 / 427,
  AppStoreEN: 1280 / 379,
  Favicon: 300 / 300,
  GoogleBlack: 716 / 160,
  GoogleBlackEnglish: 692 / 160,
  GoogleButton: 716 / 160,
  GoogleWhite: 716 / 160,
  Icon: 1024 / 1024,
  Mockup: 2600 / 1800,
  PayPal: 1452 / 1000,
  PlayStore: 4096 / 1214,
  SignInWithGoogle: 716 / 184,
  Splash: 1284 / 2778,
  Stripe: 1452 / 1000,
  Visa: 1452 / 1000,
  WhitePng: 4005 / 2604,
  BlackPng: 4005 / 2604,
};

export const ProtocolTitles = {
  PRIMARY_SQUAT: "primarySquat-string",
  SECONDARY_SQUAT: "secondarySquat-string",
  TERTIARY_SQUAT: "tertiarySquat-string",
  QUATERNARY_SQUAT: "quaternarySquat-string",
  QUINARY_SQUAT: "quinarySquat-string",
  PRIMARY_BENCH_PRESS: "primaryBenchPress-string",
  SECONDARY_BENCH_PRESS: "secondaryBenchPress-string",
  TERTIARY_BENCH_PRESS: "tertiaryBenchPress-string",
  QUATERNARY_BENCH_PRESS: "quaternaryBenchPress-string",
  QUINARY_BENCH_PRESS: "quinaryBenchPress-string",
  PRIMARY_DEADLIFT: "primaryDeadlift-string",
  SECONDARY_DEADLIFT: "secondaryDeadlift-string",
  TERTIARY_DEADLIFT: "tertiaryDeadlift-string",
  QUATERNARY_DEADLIFT: "quaternaryDeadlift-string",
  QUINARY_DEADLIFT: "quinaryDeadlift-string",
};

export const ProtocolCases = {
  RAMP: "ramp", // "Ramp 3x4 @8"
  SETS_REPS_RPE: "setsRepsRpe", // "3x4 @5"
  // WEIGHT_REPS: "weightReps", // "200x4"
  SINGLE: "single", // "Single @5"
  REPS_AND_RPE: "repsAndRpe", // "x4 @5"
  RPE_PROGRESSION: "rpeProgression", // "x3 @4-4-5"
  WEIGHT_PROGRESSION: "weightProgression", // "175-180-185 x3"
  SETS_REPS_WEIGHT: "setsRepsWeight", // "3x5x145"
};

export const Calendar = {
  DAY_WIDTH: 34,
  MAX_OPACITY: 0.55,
  BASE_COLORS: [
    "#3F7B8D",
    "#5DC460",
    "#C263F9",
    "#E2C136",
    "#FF4C4C",
    "#FF9A24",
    "#3366FF",
    "#8C8C8C",
    "#FF8FA0",
    "#7BCFFF",
  ],
};

export const UISections = {
  PROGRAM_WORKOUTS_V1: "program_workouts_v1",
  PROGRAM_BLOCK_VIEW_V1: "program_block_view_v1",
  PROGRAM_DASHBOARD_V1: "program_dashboard_v1",
  CALENDAR_V1: "calendar_v1",
  BLOCK_VIEW_UPDATE_V1: "block_view_update_v1",
  BLOCK_VIEW_TUTORIAL_BANNER_V1: "block_view_tutorial_banner_v1",
};

export const MealNames = {
  BREAKFAST: "breakfast-string",
  LUNCH: "lunch-string",
  DINNER: "dinner-string",
  SNACK: "snack-string",
  OTHER: "other-string",
};

export const FoodItemProperties = {
  CALORIES: "energy-kcal_100g",
  CARBS: "carbohydrates_100g",
  PROTEIN: "proteins_100g",
  FAT: "fat_100g",
};

export const WorkoutLimits = {
  MAX_EXERCISES_PER_WORKOUT: 20,
  MAX_SETS_PER_EXERCISE: 20,
  MAX_WORKOUTS_PER_WEEK: 7,
  MAX_WEEKS_PER_BLOCK: 24, // Constant only, no enforcement yet
};

// Microsoft Clarity project ID for analytics
// Only used during onboarding sessions when user accepts cookies
export const CLARITY_PROJECT_ID = "u6h0pfc1lm"; // Replace with actual project ID from https://clarity.microsoft.com/

// Meta (Facebook) Pixel ID for conversion tracking
// Only used during onboarding sessions when user accepts cookies
export const META_PIXEL_ID = "1367698587930110"; // Replace with actual pixel ID from Meta Events Manager
